<template>
  <div>
   <!--  <button @click="notificar">pulsar</button> -->
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";

import Snotify from "vue-snotify";
import { SnotifyPosition } from "vue-snotify";
import "vue-snotify/styles/material.css";

Vue.use(Snotify);

export default {
  data() {
    return {
      prueba: null
    };
  },
  methods: {
    ...mapActions("notifier", ["default", "success", "error", "clear"]),
    notificar: function() {     
      this.$snotify.confirm("Example body content", "Example title", {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          {
            text: "Yes",
            action: () => console.log("Clicked: Yes"),
            bold: false
          },
          { text: "No", action: () => console.log("Clicked: No") },
          {
            text: "Later",
            action: toast => {
              console.log("Clicked: Later");
              this.$snotify.remove(toast.id);
            }
          },
          {
            text: "Close",
            action: toast => {
              console.log("Clicked: No");
              this.$snotify.remove(toast.id);
            },
            bold: true
          }
        ]
      });
    }
  },
  computed: {
    ...mapState({ alert: state => state.notifier })
  },
  watch: {
    "alert.time": function(oldVal, newVal) {
      console.log(this.alert);

      this.$snotify.create({
        title: null,
        body: this.alert.message,
        config: {
          position: SnotifyPosition.rightTop,
          type: this.alert.notifyType,
          showProgressBar: false
        }
      });

      if (this.alert.type == "alert-success") {
        console.log("lanzado el alert type success");
        this.$root.$emit("bv::hide::modal", this.$root.currentModal);
      }
    }
  }
};
</script>

